export const actionTypes = {
  REQUEST_DATA_LIST_HASHTAG: 'REQUEST_DATA_LIST_HASHTAG',
  GET_DATA_LIST_HASHTAG_SUCCESS: 'GET_DATA_LIST_HASHTAG_SUCCESS',
  GET_DATA_LIST_HASHTAG_FALL: 'GET_DATA_LIST_HASHTAG_FALL'
};

export const requestListHashtag = () => ({
  type: actionTypes.REQUEST_DATA_LIST_HASHTAG
});
